export default {
  GET_CATEGORIES_TASK_CRUD_REQUEST: 'GET_CATEGORIES_TASK_CRUD_REQUEST',
  GET_SPRINTS_TASK_CRUD_REQUEST: 'GET_SPRINTS_TASK_CRUD_REQUEST',
  GET_PROJECTS_TASK_CRUD_REQUEST: 'GET_PROJECTS_TASK_CRUD_REQUEST',
  GET_PROJECT_TASK_CRUD_REQUEST: 'GET_PROJECT_TASK_CRUD_REQUEST',
  GET_STATUSES_TASK_CRUD_REQUEST: 'GET_STATUSES_TASK_CRUD_REQUEST',

  SET_CATEGORIES_TASK_CRUD: 'SET_CATEGORIES_TASK_CRUD',
  SET_SPRINTS_TASK_CRUD: 'SET_SPRINTS_TASK_CRUD',
  SET_PROJECTS_TASK_CRUD: 'SET_PROJECTS_TASK_CRUD',
  SET_SELECTED_PROJECT_TASK_CRUD: 'SET_SELECTED_PROJECT_CRUD',
  SET_PROJECT_TASK_CRUD: 'SET_PROJECT_TASK_CRUD',
  SET_STATUSES_TASK_CRUD: 'SET_STATUSES_TASK_CRUD',

  GET_SPRINTS_TASK_CRUD_AUTOCOMPLETE: 'GET_SPRINTS_TASK_CRUD_AUTOCOMPLETE',
};
